import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from '@progress/kendo-react-layout';
import cn from 'clsx';
import styles from '../style.module.scss';
import Tooltip from '@components-clean/core/tooltip';
import WidgetIconContainer from '@components-clean/core/widget-icon-container';
import { StudyDashboardWidgetProps } from '@components-clean/core/widgets/widget-interfaces';

const WidgetItem = ({
    title,
    titleTooltip,
    subtitle,
    icon,
    isDraggable,
    onClose,
    isActiveItem,
    'data-testid': testDataId,
}: StudyDashboardWidgetProps) => {
    return (
        <Tooltip position="top">
            <Card
                className={cn(
                    'widget k-border k-border-solid k-border-transparent',
                    styles.widgetCardStyling,
                    isActiveItem && styles.activeItem,
                )}
                data-testid={testDataId}
            >
                <div className={cn('k-d-flex k-align-content-center', styles.cardHeaderStyling)}>
                    <div className={cn(styles.cardTitleStyling)}>
                        {isDraggable && (
                            <FontAwesomeIcon
                                icon={['fas', 'grip-dots-vertical']}
                                className={cn('fa-lg', styles.dragIcon)}
                                data-testid="widget-item-draggable-icon"
                            />
                        )}
                        <div className={cn(styles.cardTitleTextStyling)} title={(titleTooltip || title) as string}>
                            {title}
                        </div>
                    </div>
                </div>
                <div className={cn('k-display-flex k-justify-content-start', styles.cardBody)}>
                    <div className={styles.widgetIconContainer}>{icon && <WidgetIconContainer icon={icon} />}</div>
                    <div className={cn(styles.subtitleStyling)}>
                        <div className={styles.opraTruncate} title={subtitle as string}>
                            {subtitle}
                        </div>
                    </div>
                </div>
                {isDraggable && (
                    <FontAwesomeIcon
                        icon={['far', 'close']}
                        className={cn(styles.closeIcon)}
                        onClick={(event) => {
                            event.stopPropagation();
                            onClose();
                        }}
                        data-testid={`${testDataId}-close`}
                    />
                )}
            </Card>
        </Tooltip>
    );
};

export default WidgetItem;
